export default "__VITE_PUBLIC_ASSET__6da7c019__"